export default {
  COURIER_SET: 'COURIER_SET',
};
